function createErrorMessage(error) {
  const messageByStatus = {
    500: "Algo de errado ocorreu em nossos servidores. Tente daqui alguns minutos ou contate nosso suporte.",
    400: "O cliente enviou um requisição ilegal ou mal-formada.",
    404: "Parece que o que você procura não existe em nossos registros.",
    403: "No momento, sua função não está disponível para entrada no sistema.",
    402: "Conexão com a internet não detectada. Tente se reconectar e recarregar a página.",
    401: "Usuário ou senha não encontrado, verifique e tente novamente.",
    0: "Ocorreu um erro. Tente novamente mais tarde."
  }

  const NETWORK_ERROR = "Network Error"

  function getErrorCode() {
    return error.response ? error.response.status : 0
  }

  function isErrorCodeListed() {
    return Object.keys(messageByStatus).some(
      keyMessage => String(getErrorCode()) === keyMessage
    )
  }

  function getMessage() {
    const errorMessage = error?.response?.data?.message || error?.message

    if (errorMessage) {
      if (errorMessage === NETWORK_ERROR) {
        return messageByStatus[402]
      }
      return errorMessage
    }

    if (isErrorCodeListed()) {
      return messageByStatus[getErrorCode()]
    }

    return messageByStatus[0]
  }

  return {
    getMessage,
    messageByStatus
  }
}

export default createErrorMessage
